import type { RouteRecordRaw } from 'vue-router'
import MainLayout from '@/views/layouts/MainLayout.vue'
import InstitutionsView from '@/views/formats/institutions/InstitutionsView.vue'
import { ORGANIZER_FORMAT_INSTITUTIONS_ROUTE } from '@/router/organizer/organizer-route-names.ts'

export default {
    path: '/organizer',
    meta: { requiresAuth: true, roles: ['organizer', 'reviewer'] },
    children: [
        {
            path: 'formats',
            component: MainLayout,
            children: [
                {
                    path: '',
                    name: 'formats',
                    meta: {
                        title: 'ui.organizer.formats.title',
                    },
                    component: () => import('@/views/formats/FormatsView.vue'),
                },
            ],
        },
        {
            path: 'communication',
            component: MainLayout,
            children: [
                {
                    path: ':formatId',
                    name: 'organizer-communication',
                    meta: {
                        title: 'ui.organizer.communication.title',
                    },
                    component: () => import('@/views/organizer/CommunicationView.vue'),
                    props: (route) => ({ formatId: route.params.formatId as string }),
                },
            ],
        },
        {
            path: 'formats/:formatId',
            name: 'format',
            component: () => import('@/views/formats/form/FormatChapterizedLayout.vue'),
            children: [
                {
                    path: 'format',
                    name: 'format-format-form',
                    component: () => import('@/views/formats/form/FormatFormView.vue'),
                },
                {
                    path: 'legal',
                    name: 'format-legal-form',
                    component: () => import('@/views/formats/form/LegalFormatFormView.vue'),
                },
                {
                    path: 'format/application/:applicationId',
                    name: 'format-application-form',
                    component: () =>
                        import('@/views/applications/ApplicationFormConfigurator/ApplicationFormConfigurator.vue'),
                    props: true,
                },
                {
                    path: 'format/application-preview',
                    name: 'format-application-preview',
                    component: () => import('@/views/applications/ApplicationPreview.vue'),
                    props: true,
                },
                {
                    path: 'events',
                    name: 'organizer-format-events',
                    component: () => import('@/views/events/EventsView.vue'),
                },
                {
                    path: 'schedule-start',
                    name: 'organizer-format-schedule-start',
                    component: () => import('@/views/formats/ScheduleViewStart.vue'),
                },
                {
                    path: 'schedule',
                    name: 'organizer-format-schedule',
                    component: () => import('@/views/formats/ScheduleView.vue'),
                },
                {
                    path: 'job-postings',
                    name: 'organizer-format-job-postings',
                    component: () => import('@/views/job-postings/JobPostingsView.vue'),
                },
                {
                    path: 'events/:eventId/form',
                    name: 'organizer-format-event-form',
                    component: () => import('@/views/events/form/EventFormView.vue'),
                    props: true,
                },

                {
                    path: 'job-postings/:jobPostingId/form',
                    name: 'organizer-format-job-posting-form',
                    component: () => import('@/views/job-postings/form/JobPostingFormView.vue'),
                    props: true,
                },
                {
                    path: 'company/form',
                    name: 'organizer-company-form',
                    component: () => import('@/views/company/form/CompanyFormView.vue'),
                    props: true,
                },
                {
                    path: 'institutions',
                    name: ORGANIZER_FORMAT_INSTITUTIONS_ROUTE,
                    component: InstitutionsView,
                    props: true,
                },
                {
                    path: 'summary-start',
                    name: 'organizer-format-summary-start',
                    component: () => import('@/views/formats/FormatSummary/FormatSummaryStart.vue'),
                },
                {
                    path: 'summary',
                    name: 'organizer-format-summary',
                    component: () => import('@/views/formats/FormatSummary/FormatSummary.vue'),
                },
            ],
        },
        {
            path: 'formats/:formatId/participants-applications',
            component: MainLayout,
            children: [
                {
                    path: '',
                    name: 'organizer-participants-applications',
                    component: () => import('@/views/organizer/ParticipantApplicationsView.vue'),
                    props: true,
                },
                {
                    path: ':applicationId',
                    name: 'organizer-application-detail',
                    component: () =>
                        import('@/views/organizer/ParticipantApplicationDetailView.vue'),
                    props: true,
                },
            ],
        },
    ],
} as RouteRecordRaw
